export default __webpack_public_path__ + "static/media/timesup.dba5845f.mp3";